import { render } from "./StoreView.vue?vue&type=template&id=5d3067f3&scoped=true&ts=true"
import script from "./StoreView.vue?vue&type=script&lang=ts"
export * from "./StoreView.vue?vue&type=script&lang=ts"

import "./StoreView.scss?vue&type=style&index=0&id=5d3067f3&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3067f3"]])

export default __exports__